"use client";

import { Calendar as CalendarIcon, LayoutGrid, Rows3 } from "lucide-react";

export type BuzzView = "cards" | "table" | "calendar";

export function ViewSwitcher({ view, onChange }: { view: BuzzView; onChange: (view: BuzzView) => void }) {
  const items = [
    { id: "cards" as const, label: "Cards", icon: LayoutGrid },
    { id: "table" as const, label: "Table", icon: Rows3 },
    { id: "calendar" as const, label: "Calendar", icon: CalendarIcon }
  ];
  return (
    <div className="inline-flex shrink-0 items-center gap-1 rounded-full border border-border bg-card p-1">
      {items.map(({ id, label, icon: Icon }) => {
        const active = view === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] transition ${
              active ? "bg-brand text-white" : "text-muted-foreground hover:text-foreground"
            }`}
            aria-pressed={active}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </button>
        );
      })}
    </div>
  );
}

export function FilterSelect({
  label,
  value,
  onChange,
  options
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}) {
  return (
    <label className="inline-flex items-center gap-2 rounded-full border border-border bg-card py-1 pl-3 pr-1">
      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)} className="rounded-full bg-transparent py-1 pr-2 text-[12px] font-bold uppercase tracking-[0.14em] text-foreground outline-none">
        {options.map((option) => (
          <option key={option.value} value={option.value} className="bg-card text-foreground">
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
